/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown>, last: NonNullable<unknown> }} Meta_Join_AndInputs */



/**
* | output |
* | --- |
* | "{names} and {last}" |
*
* @param {Meta_Join_AndInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_join_and = /** @type {((inputs: Meta_Join_AndInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Join_AndInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.names} und ${i?.last}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.names} et ${i?.last}`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`${i?.names}和${i?.last}`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`${i?.names} 與 ${i?.last}`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`${i?.names} 및 ${i?.last}`)
	return /** @type {LocalizedString} */ (`${i?.names} and ${i?.last}`)
});